import Route from 'cio/routes/base';
import PostRegistrationReadyController from './controller';
export default class PostRegistrationReadyRoute extends Route {
  activate() {
    super.activate();

    let controller = this.controllerFor(this.routeName) as PostRegistrationReadyController;

    controller.measureAccountReadyDelay();
  }
}
